<template>
  <div class="cms-form-layout" :class="{ 'has-sidebar': hasSidebar }">
    <div class="cms-form-main">
      <slot></slot>
    </div>
    <div v-if="hasSidebar" class="cms-form-sidebar-wrapper">
      <slot name="sidebar"></slot>
    </div>
  </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue';

const slots = useSlots();
const hasSidebar = computed(() => !!slots.sidebar);
</script>

<style lang="scss" scoped>
@import './cms-styles.scss';

.cms-form-layout {
  display: grid;
  grid-template-columns: 1fr;
  gap: $cms-spacing-md;
  max-width: 100%;
  margin: 0 auto;

  &.has-sidebar {
    grid-template-columns: 1fr 303px;
  }
}

.cms-form-main {
  min-width: 0;
}

.cms-form-sidebar-wrapper {
  display: flex;
  flex-direction: column;
  gap: $cms-spacing-md;
}

@include cms-responsive-tablet {
  .cms-form-layout {
    grid-template-columns: 1fr;
    gap: $cms-spacing-md;

    &.has-sidebar {
      grid-template-columns: 1fr;
    }
  }

  .cms-form-sidebar-wrapper {
    order: -1;
  }
}
</style>



